export const PREVIEW_CONST = {
	message: `Welcome to ${process.env.REACT_APP_QEWD_DIGEST_TITLE}. Below you will find the Top things we’ve
    selected for you to watch. Enjoy!`,
};
